import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-auth3-layout',
    templateUrl: './auth3-layout.component.html',
    styleUrls: ['./auth3-layout.component.scss'],
    standalone: false
})
export class Auth3LayoutComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {

  }

}
